// src/pages/AdminUsersPage.tsx
import React, { useState, useEffect } from 'react';
import { usersApi } from '../api';
import { useAuth } from '../context/AuthContext';
import type { User } from '../types';

export default function AdminUsersPage() {
  const { user: me } = useAuth();
  const [members, setMembers]   = useState<User[]>([]);
  const [loading, setLoading]   = useState(true);
  const [showInvite, setShowInvite] = useState(false);
  const [form, setForm]         = useState({ email:'', name:'', username:'' });
  const [saving, setSaving]     = useState(false);
  const [msg, setMsg]           = useState('');

  const load = async () => {
    setLoading(true);
    try { const { members: m } = await usersApi.listFamily(); setMembers(m); } catch {}
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const invite = async (e: React.FormEvent) => {
    e.preventDefault(); setSaving(true); setMsg('');
    try {
      await usersApi.inviteMember(form.email, form.name, form.username);
      setMsg('Invite sent!');
      setForm({ email:'', name:'', username:'' });
      setShowInvite(false);
      await load();
    } catch (err: any) { setMsg(err.response?.data?.error || 'Failed'); }
    setSaving(false);
  };

  const archive = async (userId: string) => {
    if (!window.confirm('Archive this member? Their data will be preserved.')) return;
    await usersApi.archiveMember(userId);
    await load();
  };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div style={{ fontSize:26, fontWeight:600, letterSpacing:-0.5 }}>Family Members</div>
        <button onClick={() => setShowInvite(!showInvite)} style={{
          padding:'8px 18px', borderRadius:'var(--radius-sm)', fontSize:12,
          background:'var(--green)', border:'none', color:'#0c0e14', fontWeight:600, cursor:'pointer',
        }}>
          + Invite member
        </button>
      </div>

      {showInvite && (
        <form onSubmit={invite} className="card" style={{ marginBottom:20 }}>
          <div style={{ fontSize:12, fontWeight:600, color:'var(--text2)', marginBottom:14 }}>Invite new member</div>
          {msg && <div style={{ color: msg.includes('sent') ? 'var(--green)' : 'var(--red)', fontSize:11, marginBottom:10 }}>{msg}</div>}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10, marginBottom:14 }}>
            {['email','name','username'].map(f => (
              <div key={f}>
                <label style={{ display:'block', fontSize:10, color:'var(--text3)', marginBottom:4, fontFamily:'var(--font-mono)' }}>
                  {f} *
                </label>
                <input required value={(form as any)[f]} onChange={e => setForm({...form, [f]:e.target.value})}
                  placeholder={f === 'email' ? 'name@email.com' : f}
                  style={{ width:'100%', padding:'8px 10px', background:'var(--bg3)',
                    border:'1px solid var(--border2)', borderRadius:'var(--radius-sm)',
                    color:'var(--text)', fontSize:12, outline:'none' }} />
              </div>
            ))}
          </div>
          <div style={{ display:'flex', gap:10 }}>
            <button type="submit" disabled={saving} style={{
              padding:'8px 18px', borderRadius:'var(--radius-sm)', fontSize:12,
              background:'var(--green)', border:'none', color:'#0c0e14', fontWeight:600, cursor:'pointer',
            }}>
              {saving ? 'Sending...' : 'Send invite'}
            </button>
            <button type="button" onClick={() => setShowInvite(false)} style={{
              padding:'8px 14px', borderRadius:'var(--radius-sm)', fontSize:12,
              background:'transparent', border:'1px solid var(--border)', color:'var(--text2)', cursor:'pointer',
            }}>
              Cancel
            </button>
          </div>
        </form>
      )}

      {loading ? (
        <div style={{ color:'var(--text3)', fontSize:12 }}>loading...</div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
          {members.map(m => (
            <div key={m.userId} className="card" style={{ display:'flex', alignItems:'center', gap:14 }}>
              <div style={{ width:36, height:36, borderRadius:'50%', background:'var(--bg3)',
                border:'1px solid var(--border2)', display:'flex', alignItems:'center',
                justifyContent:'center', fontSize:14, flexShrink:0 }}>
                {m.name?.[0]?.toUpperCase() || '?'}
              </div>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:13, fontWeight:500 }}>{m.name}</div>
                <div style={{ fontSize:10, color:'var(--text3)', fontFamily:'var(--font-mono)', marginTop:2 }}>
                  @{m.username} · {m.email} · {m.role}
                </div>
              </div>
              <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                <span style={{
                  fontSize:9, padding:'2px 8px', borderRadius:3,
                  background: m.status === 'active' ? 'var(--green-dim)' : 'var(--bg3)',
                  color: m.status === 'active' ? 'var(--green)' : 'var(--text3)',
                  border: `1px solid ${m.status === 'active' ? 'rgba(0,229,160,0.2)' : 'var(--border)'}`,
                  fontFamily:'var(--font-mono)',
                }}>
                  {m.status}
                </span>
                {m.userId !== me?.userId && m.status === 'active' && (
                  <button onClick={() => archive(m.userId)} style={{
                    padding:'4px 10px', borderRadius:'var(--radius-sm)', fontSize:10,
                    background:'var(--red-dim)', border:'1px solid rgba(255,94,125,0.2)',
                    color:'var(--red)', cursor:'pointer',
                  }}>
                    Archive
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
